class outSystemInfoCtrl {
    constructor($scope, $filter, logger, httpRequest, $state, formvalidateApi) {
        const nowTime = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
        // 初始化数据
        $scope.item = {
            busSecretKey: '',
            busStatus: 1,
            busSysId: '',
            busSysName: '',
            busUserName: '',
            busUserPwd: '',
            createTime: nowTime,
            createUser: $scope.pageState.userInfo.user.userName,
            description: '',
            remark: '',
            state: 0,
            tenantId: 0,
            updateTime: nowTime,
            updateUser: $scope.pageState.userInfo.user.userName,
            callbackUrl: '',
            callbackSecret: '',
        }
        for (const key in $scope.pageState.system) {
            $scope.item[key] = $scope.pageState.system[key]
        }
        // 完成
        $scope.subSystem = function subSystem() {
            const result = formvalidateApi.run()
            if (!result) {
                return
            }
            if ($scope.pageState.addflag) {
                // 新增
                $scope.item.createTime = nowTime
                $scope.item.createUser = $scope.pageState.userInfo.user.userName
                httpRequest.post_outSystemInfo($scope.item).then((res) => {
                    if (res.status === 200) {
                        if (res.data.value) {
                        // 存在数据false
                            logger.logError('业务系统编码已存在！')
                        } else {
                        // 不存在数据true
                            httpRequest.post_outSystemAdd($scope.item, '新增成功！').then((res) => {
                                $state.go('system.syssetting.outSystem.list')
                            })
                        }
                    }
                })
            } else {
                // 编辑
                $scope.item.updateTime = nowTime
                $scope.item.updateUser = $scope.pageState.userInfo.user.userName
                httpRequest.post_outSystemUpdate($scope.item, '编辑成功！').then((res) => {
                    $state.go('system.syssetting.outSystem.list')
                })
            }
        }
        // 取消
        $scope.clearinfo = function clearinfo() {
            $state.go('system.syssetting.outSystem.list')
        }
    }
}
outSystemInfoCtrl.$inject = ['$scope', '$filter', 'logger', 'httpRequest', '$state', 'formvalidateApi']
export default outSystemInfoCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/outsystem/outSystemInfoCtrl.js